import * as yup from 'yup'
import { REQUIRED_MESSAGE } from 'validations/messages'

export const yupValidacaoEstadoCivil = yup.object().shape({
  estadoCivil: yup.string().required(REQUIRED_MESSAGE('Estado civil')),
})
